module.exports = new __parcel__URL__("shop_machines_mother_wolf_statue.b3363a4b.png").toString();